import type React from 'react';
import { useState } from 'react';
import type { Question as QuestionJSON } from 'schema-dts';
import Question from './Question';
import type { FaqState } from '../../../ssr/src/Outlet/ShoppingCart/ShoppingCartSchema';
import LdJson from '../LdJson/LdJson';

export interface FaqProps {
  faqs: FaqState['faqItems'];
}

const FAQ: React.FC<FaqProps> = ({ faqs }) => {
  const [visibility, setVisibility] = useState<boolean[]>(
    faqs.map(() => false),
  );

  const toggleFAQ = (key: number): void => {
    const newVisibility = [...visibility];
    newVisibility[key] = !newVisibility[key];
    setVisibility(newVisibility);
  };

  return (
    <>
      <LdJson
        jsonData={{
          '@type': 'FAQPage',
          mainEntity: [
            ...faqs.map<QuestionJSON>((doc) => ({
              '@type': 'Question',
              acceptedAnswer: {
                '@type': 'Answer',
                text: doc.answer,
              },
              name: doc.question,
            })),
          ],
        }}
      />
      {faqs.map((faq, i) => (
        <Question
          key={faq.question}
          question={faq.question}
          answer={faq.answer}
          onToggle={() => toggleFAQ(i)}
          isOpen={visibility[i] ?? false}
        />
      ))}
    </>
  );
};

export default FAQ;
